<template>

  <div id="DeliveryDetails">
    <HomePageTop />
    <Dialog ref="dialog" :config="config" />
    <div class="DeliveryDetailcontent">
      <div class="headerbox">
        <h1>
          <span>
            {{ $fanyi('配送单详情') }}
          </span>
        </h1>
        <div class="DeliveryDetailsTitle">
          <span>{{ $fanyi('配送单号') }}：{{ porder_sn }}</span>
        </div>
        <div style="margin-top:10px;">
          <span class="tishibox" v-if="['待付款', '报价中', '等待付款', '乌克兰国内配送中'].indexOf(
            pageStatus
          ) != -1
          ">
            {{ $fanyi('如果您想要修改配送单信息，请联系您的负责人员') }}
          </span>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$fanyi('订单详情')" name="porder_sn">
          <div class="main">
            <div class="tablebox">
              <div class="tablehead">

                <div class="index"></div>
                <!-- 产品 -->
                <div class="products">
                  {{ $fanyi('产品') }}
                </div>
                <!-- 规格 -->
                <div class="specifications"> {{ $fanyi('规格') }}</div>
                <!-- 单价 -->
                <div class="price"> {{ $fanyi('单价') }}（₴）</div>
                <!-- 购买数量 -->
                <div class="num"> {{ $fanyi('购买数量') }}</div>
                <!-- 总价 -->
                <div class="totalprice"> {{ $fanyi('总价') }}（₴）</div>
                <!-- 国内运费 -->
                <div class="internationalfreight"> {{ $fanyi('国内运费') }}（₴）</div>
                <!-- 提货数量 -->
                <div class="pickquantities"> {{ $fanyi('提货数量') }}</div>
                <!-- 备注 -->
                <div class="remarks">{{ $fanyi('备注') }}</div>
              </div>
              <div class="tableboday" v-loading="loading">
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item :name="index" v-for="(item, index) in tableData" :key="index"> <template
                      slot="title">
                      <div class="ordersn">
                        {{ $fanyi('订单号') }} :<span @click="
                          $fun.toPage(
                            '/orderDetails?type=' +
                            'peisong' +
                            '&order_sn=' +
                            item.order_sn
                          )
                          ">{{ item.order_sn }}</span>
                      </div>
                    </template>
                    <div class="gooditem" v-for="(goodsItem, goodsIndex) in item.order_detail" :key="goodsIndex">
                      <div class="index">
                        <div class="indexNum">
                          {{ goodsIndex + 1 }}
                        </div>
                        <el-popover placement="right" trigger="hover">
                          <img :src="goodsItem.pic" alt="" style="width: 288px; height: 300px" />

                          <el-image slot="reference" @click="
                            $fun.toCommodityDetails({
                              goods_id: goodsItem.goods_id,
                              shop_type: goodsItem.shop_type,
                              mi_id: goodsItem.mi_id || '',
                            })
                            " :src="goodsItem.pic">
                            <div slot="error" :src="goodsItem.pic" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                            <div slot="placeholder">
                              <i class="el-icon-loading"></i>
                            </div>
                          </el-image>
                        </el-popover>
                      </div>
                      <!-- 产品 -->
                      <div class="products">
                        <el-popover placement="bottom" width="400" trigger="hover">
                          <div class="goodsTitleAll">
                            {{ goodsItem.goods_title }}
                          </div>

                          <div class="goodsTitle" slot="reference" style="cursor: pointer" @click="
                            $fun.toCommodityDetails({
                              goods_id: goodsItem.goods_id,
                              shop_type: goodsItem.shop_type,
                            })
                            ">
                            {{ goodsItem.goods_title }}
                          </div>
                        </el-popover>
                      </div>
                      <!-- 规格 -->
                      <div class="specifications">
                        <el-popover placement="bottom" trigger="hover">
                          <div class="goodsDetailAll">
                            <div class="goodsDetailAllOneBox" v-for="(detailItem, detailIndex) in goodsItem.detail"
                              :key="detailIndex">
                              <h1 style="font-weight: 700;" class="detailTitle">{{ detailItem.key }}</h1>
                              <p>
                                <span class="detailBody">{{
                                  detailItem.value
                                }}</span>
                              </p>
                            </div>
                          </div>
                          <div class="detailOptBox" slot="reference">
                            <p class="detailOpt" v-for="(detailItem, detailIndex) in goodsItem.detail"
                              :key="detailIndex">
                              <span> {{ detailItem.key }}</span>
                              :{{ detailItem.value }}

                            </p>
                          </div>
                        </el-popover>
                      </div>
                      <!-- 单价 -->
                      <div class="price"> {{ $fun.RMBNumSegmentation($fun.ceil(goodsItem.confirm_price *
                        item.order.exchange_rate)) }}
                      </div>
                      <!-- 购买数量 -->
                      <div class="num"> {{ goodsItem.confirm_num }}</div>
                      <!-- 总价 -->
                      <div class="totalprice"> {{ $fun.RMBNumSegmentation($fun.ceil(goodsItem.totalPrice *
                        item.order.exchange_rate))
                      }}</div>
                      <!-- 国内运费 -->
                      <div class="internationalfreight"> {{ $fun.RMBNumSegmentation($fun.ceil(goodsItem.confirm_freight
                        *
                        item.order.exchange_rate)) }}</div>
                      <!-- 提货数量 -->
                      <div class="pickquantities"> {{ goodsItem.submitNum }}</div>
                      <!-- 备注 -->
                      <div class="remarks">
                        <p v-if="goodsItem.client_remark">{{ goodsItem.client_remark }}</p>
                        <p v-else>{{ $fanyi('没有备注') }}</p>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$fanyi('装箱单')" name="deliveryorder">
          <!-- 装箱单信息-->
          <div class="Packinglist">
            <!-- <div class="headerrbox">
              <h2>{{ $fanyi('装箱单') }}</h2>
              <div class="headerdeliveryorderbox">
                <span v-for="(packingitem, ind) in deliverypackinglist"
                  :class="{ activepackingitem: packingitem.checked }" @click="packingitemclick(packingitem)"
                  :key="ind">{{
                    packingitem.porder_sn }}</span>
              </div>
            </div> -->
            <!--费用地址信息  -->
            <div class="costbox">
              <div class="costboxrow">
                <!-- 国际运输费用 -->
                <div class="Internationaltransportationcosts">
                  <h2>{{ $fanyi('国际运输费用') }}</h2>
                  <div class="cost">
                    <!-- 国际物流成本 -->
                    <div class="costitem">
                      <span>{{ $fanyi('国际物流成本') }}:</span>
                      <span>₴{{ packinglistdetails.logistics_price }} ({{ (packinglistdetails.logistics_price /
                        packinglistdetails.exchange_rate).toFixed(2) }}￥)</span>
                    </div>
                    <!-- 当地物流成本 -->
                    <div class="costitem">
                      <span>{{ $fanyi('当地物流成本') }}:</span>
                      <span>₴{{ packinglistdetails.foreign_express_price }} ({{
                        (packinglistdetails.foreign_express_price /
                          packinglistdetails.exchange_rate).toFixed(2) }}￥)</span>
                    </div>
                    <!--其他费用  -->
                    <div class="costitem">
                      <span>{{ $fanyi('其他费用') }}:</span>
                      <span>₴{{ packinglistdetails.other_price }} ({{
                        (packinglistdetails.other_price /
                          packinglistdetails.exchange_rate).toFixed(2) }}￥)</span>
                    </div>
                    <!--汇率  -->
                    <div class="costitem">
                      <span>{{ $fanyi('汇率') }}:</span>
                      <span class="huilv">1CNY ≈ {{ packinglistdetails.exchange_rate }} ₴</span>
                    </div>
                    <!-- 总成本 -->
                    <div class="costitem">
                      <span>{{ $fanyi('总成本') }}:</span>
                      <span>₴{{ Number(packinglistdetails.total_price).toFixed(2) }}({{
                        (packinglistdetails.total_price /
                          packinglistdetails.exchange_rate).toFixed(2) }}￥)</span>
                    </div>
                  </div>

                  <!-- 装箱单状态 -->
                  <div class="Packingliststatusbox">
                    <div class="Packingliststatus">
                      <!-- 装箱单状态 -->
                      <span>{{ $fanyi('装箱单状态') }}</span>
                      <span :class="{ afterPayment: Number(packinglistdetails.status) >= 50 }" class="status">{{
                        Packingliststatus(packinglistdetails.status) }}</span>
                    </div>

                    <div v-if="Number(packinglistdetails.status) == 30" @click="goPay(porder_sn)" class="pay">{{
                      $fanyi('支付')
                    }}
                    </div>

                    <div v-if="Number(packinglistdetails.status) == 64" @click="sign()" class="signfor">{{
                      $fanyi('签收')
                    }}
                    </div>
                  </div>
                </div>

                <!-- 发货信息 -->
                <div class="Shippinginformation">
                  <h2>{{ $fanyi('发货信息') }}</h2>
                  <div class="informationbox">
                    <div class="information">
                      <!-- Rakumart装箱单单号 -->
                      <span>{{ $fanyi('装箱单号') }} :</span>
                      <span> {{ packinglistdetails.porder_sn }}</span>
                    </div>
                    <!-- 收件人 -->
                    <div class="information">
                      <span> {{ $fanyi('收件人') }}:</span>
                      <span> {{ packinglistdetails.receive.contacts }}</span>
                    </div>
                    <!-- 地址 -->
                    <div class="information">
                      <span>{{ $fanyi('地址') }}: </span>
                      <span>{{ packinglistdetails.receive.address }}
                      </span>
                    </div>
                    <!-- 城市 -->
                    <div class="information">
                      <span>{{ $fanyi('城市') }}: </span>
                      <span>{{ packinglistdetails.receive.city }} </span>
                    </div>
                    <!-- 州 -->
                    <div class="information">
                      <span>{{ $fanyi('地区/州') }}: </span>
                      <span> {{ packinglistdetails.receive.state }}</span>
                    </div>
                    <!-- 邮编 -->
                    <div class="information">
                      <span>{{ $fanyi('邮编') }}: </span>
                      <span> {{ packinglistdetails.receive.zip_code }}</span>
                    </div>
                    <!-- 电话 -->
                    <div class="information">
                      <span> {{ $fanyi('电话') }}:</span>
                      <span> {{ packinglistdetails.receive.mobile }} </span>
                    </div>
                    <!-- 邮箱 -->
                    <div class="information">
                      <span> {{ $fanyi('邮箱') }}:</span>
                      <span>{{ packinglistdetails.receive.email }} </span>
                    </div>
                  </div>
                </div>

                <!-- 装箱单备注 -->
                <div class="Remarksofpackinglist">
                  <h2>{{ $fanyi('装箱单备注') }}</h2>
                  <textarea v-model="packinglistdetails.client_remark" :disabled="true"></textarea>
                  <h2>{{ $fanyi('包括以下订单中的产品') }}</h2>
                  <el-table height="155" :header-cell-style="{
                    'text-align': 'center',
                    'font-size': '14px ',
                    color: 'black',
                    'font-weight': '500',
                    background: '#F6F6F6',
                    height: '38px !important',
                    padding: '5px'
                  }" :cell-style="{
                    'text-align': 'center',
                    padding: '4px',
                    height: '38px !important', 'font-size': '14px',
                  }" :data="packinglistdetails.order_sn" border style="width: 100%">
                    <el-table-column prop="no" label="NO" width="139">
                    </el-table-column>
                    <el-table-column prop="order_sn" :label="$fanyi('订单号')" width="260">
                      <template slot-scope="scope">
                        <div @click="openorderDetails(scope.row.order_sn)" class="order_sn">
                          {{ scope.row.order_sn }}
                        </div>
                      </template>

                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>


            <!-- 物流信息 -->
            <div class="Logisticsinformation"> <!-- 配送单列表 -->
              <div class="Distributionlist">
                <el-table :header-cell-style="{
                  'text-align': 'center',
                  'font-size': '14px ',
                  color: '#222222 ',
                  'font-weight': '500',
                  background: '#F5F5F5',
                  height: '48px !important',
                  padding: '5px'
                }" :cell-style="{
                  'text-align': 'center',
                  padding: '4px',
                  height: '48px !important', 'font-size': '14px',
                }" :data="LogisticsInfo" border style="width: 100%">
                  <!-- 运单号 -->
                  <el-table-column :label="$fanyi('运单号')">
                    <template slot-scope="scope">
                      <div @click="waybill(scope.row)" class="waybill">
                        {{ scope.row.express_no }}
                      </div>
                    </template>
                  </el-table-column>
                  <!-- 物流方式 -->
                  <el-table-column :label="$fanyi('物流方式')">
                    <template slot-scope="scope">
                      <div>{{ scope.row ? scope.row.logistics_info.name : '' }}</div>
                    </template>
                  </el-table-column>
                  <!-- 装箱数量 -->
                  <el-table-column prop="box_number" :label="$fanyi('装箱数量')"> <template slot-scope="scope">
                      <div>{{ scope.row.box_number }}</div>
                    </template>
                  </el-table-column>
                  <!-- 重量 -->
                  <el-table-column prop="weight" :label="$fanyi('重量') + '(KG)'"><template slot-scope="scope">
                      <div>{{ scope.row.weight }}</div>
                    </template>
                  </el-table-column>
                  <!-- 体积 -->
                  <el-table-column prop="volume" :label="$fanyi('体积') + '(m³)'"><template slot-scope="scope">
                      <div>{{ scope.row.volume }}</div>
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 提示 -->
                <div class="tip">
                  {{ $fanyi('提示') }} ：{{ $fanyi('您可以点击运单号查看实时物流信息') }}
                </div>
              </div>

              <!-- 跟踪物流状态 -->

              <div class="TrackingStatus">
                <h2>{{ $fanyi('跟踪状态') }}</h2>

                <div class="iconbox">
                  <!-- 已发出 -->
                  <div class="iconitem" :class="{ activeicon: getStatusArray(LogisticsInfo[0].logistics_status, 0) }">
                    <div class="imgbox">
                      <img v-if="getStatusArray(LogisticsInfo[0].logistics_status, 0)"
                        src="@/assets/OrderDetails/icon1.1.svg" alt="">
                      <img v-else src="@/assets/OrderDetails/icon1.svg" alt="">
                    </div>

                    <p>{{ $fanyi('已发出') }}</p>
                  </div>
                  <div class="line">

                  </div>
                  <!-- 运输中 -->
                  <div class="iconitem" :class="{ activeicon: getStatusArray(LogisticsInfo[0].logistics_status, 1) }">
                    <div class="imgbox">
                      <img v-if="getStatusArray(LogisticsInfo[0].logistics_status, 1)"
                        src="@/assets/OrderDetails/icon2.1.svg" alt="">
                      <img v-else src="@/assets/OrderDetails/icon2.svg" alt="">
                    </div>

                    <p>{{ $fanyi('运输中') }}</p>
                  </div>
                  <div class="line">

                  </div>
                  <!-- 本地配送中 -->
                  <div class="iconitem" :class="{ activeicon: getStatusArray(LogisticsInfo[0].logistics_status, 2) }">
                    <div class="imgbox"> <img v-if="getStatusArray(LogisticsInfo[0].logistics_status, 2)"
                        src="@/assets/OrderDetails/icon3.1.svg" alt="">
                      <img v-else src="@/assets/OrderDetails/icon3.svg" alt="">
                    </div>

                    <p>{{ $fanyi('本地配送中') }}</p>

                  </div>
                  <div class="line">

                  </div>
                  <!--已送达 -->
                  <div class="iconitem" :class="{ activeicon: getStatusArray(LogisticsInfo[0].logistics_status, 3) }">
                    <div class="imgbox">
                      <img v-if="getStatusArray(LogisticsInfo[0].logistics_status, 3)"
                        src="@/assets/OrderDetails/icon4.1.svg" alt="">
                      <img v-else src="@/assets/OrderDetails/icon4.svg" alt="">
                    </div>
                    <p>{{ $fanyi('已送达') }}</p>
                  </div>

                </div>

                <div class="textareabox" v-if="LogisticsInfo[0].information.length > 0">


                  <div class="textareaItem" v-for="(item, index) in LogisticsInfo[0].information" :key="index">
                    <div class="date">{{ item.key }}</div>
                    <div class="timebox">

                      <div class="icon"></div>
                      <div class="rightbox">
                        <div class="timeItem" v-for="(timeItem, timeindex) in item.value" :key="timeindex">
                          <div class="time"> <img src="@/assets/OrderDetails/time.svg" alt="">{{
                            timeItem.time }}
                          </div>
                          <div class="text">{{ timeItem.msg }}</div>
                        </div>
                      </div>

                    </div>
                  </div>




                </div>
                <div class="noData" v-else>{{
                  $fanyi('暂无数据')
                }}</div>

              </div>
            </div>
            <!-- 包装单详情 Packinglist details -->
            <div class="Packinglistdetails">
              <div class="detailscontent" :class="{ showCloseheight: showClose }" id="detailscontentRef">
                <div class="headertitle">
                  <!--  @click="headerclick(ite)" -->
                  <div class="left" @click="headerclick">
                    <!-- 装箱单详细信息-->
                    <span>{{ $fanyi('装箱单') }}</span>

                  </div>
                  <div class="right">
                    <!-- 提示 -->
                    <span class="tip">
                      {{ $fanyi('提示') + ': ' + $fanyi('点击这里以展开或收起') }}
                    </span>
                    <!-- 展开 -->
                    <img v-if="showClose" @click="headerclick" src="@/assets/OrderDetails/open1.svg" alt="">
                    <!-- 收齐 -->
                    <img v-else @click="headerclick" src="@/assets/OrderDetails/open1.1.svg" alt="">

                  </div>

                </div>
                <div class="maintable" v-for="(ite, index) in Packinginformation" :key="index" id="maintableRef">
                  <el-collapse v-model="PackinginactiveNames">
                    <el-collapse-item title="一致性 Consistency" name="1">
                      <template slot="title">
                        <div class="itemheader">

                          <!-- 箱号 -->
                          <div class="Cartonnumber">
                            <span> {{ $fanyi('箱号') }} :</span>
                            <span>{{ ite.number }}</span>
                          </div>
                          <!-- 规格 -->
                          <div class="specification">
                            <!-- 装有相同货物的箱子数量 -->

                            <div class="samegoods">
                              <span>{{ $fanyi('装有相同货物的箱子数量') }} :</span><span>{{ ite.total }}</span>
                            </div>
                            <!-- 重量 -->
                            <div class="Weight"> <span>{{ $fanyi('重量') }}(kg) :</span><span>{{ ite.weight }}</span>
                            </div>

                            <!-- 体积 -->
                            <div class="Volume"> <span>{{ $fanyi('体积') }} (m³):</span><span>{{ ite.volume }}</span>
                            </div>
                            <!-- 长 -->
                            <div class="Length"> <span>{{ $fanyi('长') }}(cm) :</span><span>{{ ite.length }}</span>
                            </div>
                            <!-- 宽 -->
                            <div class="Width"> <span>{{ $fanyi('宽') }}(cm) :</span><span>{{ ite.width }}</span>
                            </div>
                            <!-- 高 -->
                            <div class="Height"> <span>{{ $fanyi('高') }}(cm) :</span><span>{{ ite.height }}</span>
                            </div>

                          </div>
                        </div>

                      </template>
                      <!-- 表格区域 -->
                      <el-table :header-cell-style="{
                        'text-align': 'center',
                        'font-size': '14px ',
                        color: '#222222 ',
                        'font-weight': '500',
                        background: '#F6F6F6',
                        height: '40px !important',
                        padding: '5px'
                      }" :cell-style="{
                        'text-align': 'center',
                        padding: '4px',
                        height: '100px', 'font-size': '14px',
                      }" :data="ite.goods" border style="width: 100%">
                        <!-- 订单号 -->
                        <el-table-column width="220" :label="$fanyi('订单号')">
                          <template slot-scope="scope">
                            <div class="waybill">
                              {{ scope.row.order_sn }}
                            </div>
                          </template>
                        </el-table-column>
                        <!-- 序号 -->
                        <el-table-column prop="sorting" width="80" :label="$fanyi('NO')">
                        </el-table-column>
                        <!-- 商品图片 -->
                        <el-table-column prop="pic" width="110" :label="$fanyi('商品图片')">
                          <template slot-scope="scope">
                            <el-popover placement="right" trigger="hover">
                              <img :src="scope.row.pic" alt="" style="width: 288px; height: 298px" />

                              <img class="goodimg" :src="scope.row.pic" alt="" slot="reference" />
                            </el-popover>
                          </template>

                        </el-table-column>
                        <!-- 商品链接 -->
                        <el-table-column prop="url" width="200" :label="$fanyi('商品链接')">
                          <template slot-scope="scope">

                            <el-popover placement="top-start" width="300" trigger="hover">
                              <div>{{ scope.row.url }}</div>
                              <div slot="reference" class="goods_title">
                                {{ scope.row.url }}
                              </div>

                            </el-popover>

                          </template>
                        </el-table-column>
                        <!-- 产品英文名称 -->
                        <el-table-column prop="goods_title" width="160" :label="$fanyi('产品英文名称')">
                          <template slot-scope="scope">

                            <el-popover placement="top-start" width="400" trigger="hover">
                              <div>{{ scope.row.goods_title }}</div>
                              <div slot="reference" class="goods_title">
                                {{ scope.row.goods_title }}
                              </div>

                            </el-popover>

                          </template>
                        </el-table-column>
                        <!-- 商品属性 -->
                        <el-table-column prop="name" width="200" :label="$fanyi('商品属性')
                          "> <template slot-scope="scope">
                            <p v-for="(column, ind) in scope.row.detail" :key="ind"><span>{{ column.key }}:</span>
                              <span>{{
                                column.value }}</span>
                            </p>
                          </template>
                        </el-table-column>
                        <!-- 包装数量 -->
                        <el-table-column prop="num" :label="$fanyi('包装数量')">
                        </el-table-column>
                        <!-- 单价 -->
                        <el-table-column prop="price_usd" :label="$fanyi('单价') + '(₴)'">
                        </el-table-column>
                        <!-- 小计 -->
                        <el-table-column prop="total_price_usd" :label="$fanyi('小计') + '(₴)'">
                        </el-table-column>
                      </el-table>
                    </el-collapse-item>

                  </el-collapse>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 提示弹窗 -->
      <!-- 通关方式 -->
      <tongGuanFangShiVue v-if="activeName == 'porder_sn'" :datas="datas"></tongGuanFangShiVue>
      <!-- 物流方式 -->
      <logisticsmodemode v-if="activeName == 'porder_sn'" />
      <!--  -->
      <!-- 提示弹窗 -->
      <customerPrompt ref="customerPrompt" style="background: transparent; box-shadow: none; height: 0px">
      </customerPrompt>
      <!-- 操作栏 -->
      <caozuolanVue @showSelectCouponDialogVisible="showSelectCouponDialogVisible" />
      <Dialog ref="dialog" :config="config" />
      <!-- 优惠劵弹窗 -->
      <Coupons @Usecoupons="Usecoupons" ref="CouponDialogRef" />
    </div>

  </div>
</template>
<script>
import HomePageTop from '../../../../../../components/head/HomePageTop.vue'
import customerPrompt from './components/customerPrompt'
import tongGuanFangShiVue from './components/tongGuanFangShi.vue'
import logisticsmodemode from './components/logisticsmode.vue'
import caozuolanVue from './components/caozuolan.vue'
import Dialog from '@/components/public/Dialog.vue'


import Coupons from '../../../userOrder/views/components/Coupons.vue'



export default {
  name: 'DeliveryDetails',
  data() {
    return {
      activeNames: [],
      loading: false,
      datas: { result: {} }, //所有数据
      tableData: [], //上面表格数据
      checked: false, //全选
      pageStatus: '报价中', //页面状态，参数：临时保存、报价中、等待付款、待发货
      timer: '',
      couponChecked: false,
      PackinginactiveNames: ['1'],
      activeName: 'deliveryorder',
      deliverypackinglist: [],//配送单单号列表
      packinglistdetails: {
        logistics_price: 0,
        foreign_express_price: 0,
        other_price: 0,
        exchange_rate: 0,
        receive: {}
      },
      LogisticsInfo: [{
        information: '', logistics_info: {
          name: ''
        }
      }],//物流信息
      showClose: true,
      Packinginformation: [],// 装箱信息
      // 接口请求条件
      form: {
        ids: this.$route.query.id,
        personal_clearance: 'yes',
        logistics: '',
        client_remark: '',
      },
      istouseCoupon: '',// 是否使用优惠劵
      wuliu: [],
      // 订单其他信息
      orderData: {
        shangPinZhongLei: 0, //商品种类
        shuLiangZongJi: 0, //数量总计
        zongJia: 0, //总价(人民币)
      },
      CouponsData: {
        id: '',
        title: '',
      },
      // 配送单号
      porder_sn: '',

      //选择的地址名字
      userActiveAddName: {
        importer: '',
        consignee: '',
      },
      //选择的地址详细信息
      userActiveAdd: {
        importer: {
          user_id: 1,
          type: 1,
          company: '',
          zip_code: '',
          address: '',
          contacts: '',
          mobile: '',
          tel: '',
          mark: '',
          email: '',
          cnpj: '',
        },
        consignee: {
          user_id: 1,
          type: 2,
          company: '',
          zip_code: '',
          address: '',
          contacts: '',
          mobile: '',
          tel: '',
          mark: '',
          email: '',
          cnpj: '',
        },
      },
      //用户地址列表
      useraddLists: {},
      wuLiuOptions: [], //物流方式列表
      showAdd: false, //是否显示添加商品弹窗
      config: {
        top: '20vh',
        width: '500px',
        title: this.$fanyi('提示'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
    }
  },
  components: {
    HomePageTop,
    customerPrompt,
    tongGuanFangShiVue,
    logisticsmodemode,
    caozuolanVue,
    Dialog,
    Coupons,

  },
  computed: {},
  created() {
    // 获取数据
    this.getData()
    // 获取用户地址
    this.useraddressList()
    // // 获取物流方式列表
    // // 获取物流方式列表
    this.packingList(this.$route.query.order_sn)
    this.getLogisticsInfo(this.$route.query.order_sn)
    this.getPackingInfo(this.$route.query.order_sn)

  },
  methods: {
    // 获取数据
    getData() {
      this.loading = true
      if (this.$route.query.order_sn) {
        this.$api
          .storageDeliverDetail({ porder_sn: this.$route.query.order_sn })
          .then((res) => {
            this.loading = false
            if (res.code != 0) return
            this.porder_sn = res.data.porder_sn
            this.datas = res.data
            this.wuliu = res.data.result.porder_foreign_express

            this.pageStatus = res.data.result.status_name
            // 备注
            this.form.client_remark = res.data.result.client_remark
            // 地址
            if (res.data.result.importer) {
              this.userActiveAdd.importer = res.data.result.importer
            }
            if (res.data.result.receive) {
              this.userActiveAdd.consignee = res.data.result.receive
            }
            // 通关方式
            if (res.data.result.personal_clearance_name == 'Rakumart代通关') {
              this.form.personal_clearance = 'yes'
            } else if (res.data.result.personal_clearance_name == '个人通关') {
              this.form.personal_clearance = 'no'
            }
            this.tableData = this.datas.result.porder_detail
            this.tableData.forEach((row, i) => {
              this.activeNames.push(i)
            })

            // 调用弹出提示函数
            this.$refs.customerPrompt.openOrderDia()
            this.detailDataTreating()
            this.$api.internationalLogisticsTransportation().then((res) => {
              if (res.code != 0) return
              if (res.data.length == 0) return false
              res.data.forEach((item) => {
                if (
                  item.useful_rule.logistics_id === this.datas.result.logistics
                ) {
                  this.form.logistics = item.name
                }
              })
              this.wuLiuOptions = res.data
            })
          })
      }
      // 乌克兰新版暂时没有临时保存
      else if (this.$route.query.id) {
        this.pageStatus = '临时保存'
        this.$api
          .storageSendDeliverPreview({ ids: this.form.ids })
          .then((res) => {
            if (res.code != 0) return
            this.datas = res.data

            this.porder_sn = res.data.porder_sn
            this.tableData = res.data.result
            // 进口商地址默认赋值
            this.userActiveAdd.importer = this.datas.importer_address
            // 调用弹出提示函数
            this.$refs.customerPrompt.openOrderDia()
            this.dataTreating()
            this.$api.internationalLogisticsTransportation().then((res) => {
              if (res.code != 0) return
              if (res.data.length == 0) return false
              res.data.forEach((item) => {
                if (
                  item.useful_rule.logistics_id === this.datas.result.logistics
                ) {
                  this.form.logistics = item.name
                }
              })
              this.wuLiuOptions = res.data
            })
          })
      }
    },

    showSelectCouponDialogVisible() {
      //打开优惠劵弹窗
      this.$refs.CouponDialogRef.open('deliveryorder', this.datas.result.amount)
    },

    // 配送单详情处理数据
    detailDataTreating() {

      this.orderData = {
        shangPinZhongLei: 0, //商品种类
        shuLiangZongJi: 0, //数量总计
        zongJia: 0, //总价(人民币)
      }
      this.tableData.forEach((orderItem) => {

        orderItem.checked = false
        // orderItem.order_detail = [orderItem.order_detail];
        orderItem.order_detail.forEach((goodsItem) => {
          this.orderData.shangPinZhongLei++
          this.orderData.shuLiangZongJi += Number(goodsItem.submitNum)
          goodsItem.totalPrice = this.$fun.ceil(
            goodsItem.confirm_num * goodsItem.confirm_price
          )
          goodsItem.checked = false
        })
      })

      //费用总计= 其他费用+国际物流费用+乌克兰物流费用+增值税+反倾销税，因为购买商品的费用在之前已经支付过了
      this.orderData.zongJia =
        Number(this.datas.result.other_price) +
        Number(this.datas.result.logistics_price) +
        Number(this.datas.result.foreign_express_price) +
        Number(this.datas.result.added_price) +
        Number(this.datas.result.clearance_price)
    },
    headerclick(row) {
      this.showClose = !this.showClose
      this.$forceUpdate()
    },
    // 配送单的packinglist
    async packingList(porder_sn) {


      const res = await this.$api.packinglist({
        porder_sn: porder_sn,
      })
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.packinglistdetails = res.data


    },
    waybill(row) {

      if (row.logistics_info.url) {
        if (Number(row.logistics_info.is_inquire) == 1) {
          window.open(row.logistics_info.url + row.express_no)
        } else {
          window.open(row.logistics_info.url)
        }

      }



    },
    // 点击table切换
    handleClick() { },
    async getLogisticsInfo(porder_sn) {
      const res = await this.$api.getLogisticsInfo({
        porder_sn: porder_sn,
      })
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.LogisticsInfo = res.data
    },

    async getPackingInfo(porder_sn) {
      const res = await this.$api.getPackingInfo({
        porder_sn: porder_sn,
      })
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.Packinginformation = res.data


    },
    getStatusArray(status, index) {

      let ind = ['Отправлено', 'В пути', 'В процессе местной доставки', 'Доставлено'].findIndex((i) => i == status)

      if (ind !== -1) {
        if (index <= ind) {
          return true
        }
        else {
          return false
        }
      } else {
        return false
      }
    },

    packingitemclick(packingitem) {
      this.deliverypackinglist.forEach((item) => {
        item.checked = false
      })
      packingitem.checked = true
      this.porder_sn = packingitem.porder_sn
      this.packingList(packingitem.porder_sn)
      this.getLogisticsInfo(packingitem.porder_sn)
      this.getPackingInfo(packingitem.porder_sn)
      this.$forceUpdate()
    },

    Packingliststatus(status) {
      //       已删除 ：-1
      // 临时保存 ：10
      // 正式提交 ：20
      // 业务已翻译待装箱 ：21
      // 已装箱完成待报价 ：22
      // 已报价 ：30 待支付 ：30
      // 已支付待确认 ：40
      // 已支付已确认 ：50
      // 已订舱待回复 ：51
      // 待装柜 ：52
      // 待出货 ：53
      // 已发出 ：60
      // 已通关 ：62
      // 西班牙国内开始派送 ：64
      // 客户已签收 ： 70
      // 异常 ： -2
      let textStr = ''
      if (Number(status) == -1) {
        textStr = this.$fanyi('已删除')
      }
      if (Number(status) == 10) {
        textStr = this.$fanyi('临时保存')
      }
      if (Number(status) == 20) {
        textStr = this.$fanyi('正式提交')
      }
      if (Number(status) == 21) {
        textStr = this.$fanyi('业务已翻译待装箱')
      }
      if (Number(status) == 22) {
        textStr = this.$fanyi('已装箱完成待报价')
      }
      if (Number(status) == 30) {
        textStr = this.$fanyi('待支付')
      }
      if (Number(status) == 40) {
        textStr = this.$fanyi('已支付待确认')
      }
      if (Number(status) == 50) {
        textStr = this.$fanyi('已支付已确认')
      }
      if (Number(status) == 51) {
        textStr = this.$fanyi('已订舱待回复')
      }
      if (Number(status) == 52) {
        textStr = this.$fanyi('待装柜')
      }
      if (Number(status) == 53) {
        textStr = this.$fanyi('待出货')
      }
      if (Number(status) == 60) {
        textStr = this.$fanyi('已发出')
      }
      if (Number(status) == 62) {
        textStr = this.$fanyi('已通关')
      }
      if (Number(status) == 64) {
        textStr = this.$fanyi('乌克兰国内配送中')
      }
      if (Number(status) == 70) {
        textStr = this.$fanyi('已签收')
      }
      if (Number(status) == -2) {
        textStr = this.$fanyi('异常')
      }


      return textStr
    },
    // 前往付款页面
    goPay() {
      this.$fun.toPage(
        '/payment?porder_sn=' +
        this.porder_sn + '&coupon_ids=' +
        this.CouponsData.id
      )
    },
    // 配送单支付
    pay(porder_sn) {
      this.$fun.toPage(
        '/payment?porder_sn=' +
        porder_sn +
        '&peiSong=true'
      )
    },
    Usecoupons(row) {
      // 重新计算价格
      this.CouponsData = row
      if (row !== '') {
        this.istouseCoupon = true
      } else {
        this.istouseCoupon = false
      }
      this.getActiveCoupon()
      this.$forceUpdate()
    },
    //将选择的优惠券后的价格重新计算
    async getActiveCoupon() {
      const res = await this.$api.storagePOrderPayment({
        porder_sn: this.porder_sn,
        coupon_ids: this.CouponsData.id ? this.CouponsData.id : '',
      })
      if (res.code == 10000) {
        this.$message.error(this.$fanyi(res.msg))
        return
      }
      this.datas.result.amount = res.data.porder_amount
    },
    // 签收
    sign() {
      //派送中配送单签收

      this.$refs.dialog.open(
        this.$fanyi('是否签收选中的商品？'),
        (cancel) => {
          this.$api
            .internationalLogisticsClientReceive({ porder_sn: this.porder_sn })
            .then((res) => {
              cancel()
              if (res.code != 0) return
              this.$message.success(this.$fanyi('签收成功'))
              this.$router.push('/user/packinglist')
            })
        },
        () => {

        }
      )
    },
    // 获取用户所有地址
    useraddressList() {
      this.$api.useraddressList().then((res) => {
        if (res.code != 0) return false
        this.useraddLists = res.data

        // 检查用户是否有修改过收货地址
        let notNull = false
        for (let consiitem in this.userActiveAdd.consignee) {
          if (
            ['id', 'mark', 'type', 'user_Id'].indexOf(
              this.userActiveAdd.consignee[consiitem]
            ) == -1 &&
            this.userActiveAdd.consignee[consiitem]
          ) {
            notNull = true
          }
        }

        // 如果收货列表存在并且配送单状态是临时保存并且用户未填写地址时匹配默认地址,另外一个页面打开的时候不需要匹配，因为默认是代通关，如果个人通关用户一定填了地址
        if (
          this.useraddLists.consignee &&
          ['临时保存'].indexOf(this.pageStatus) != -1 &&
          notNull == true
        ) {
          this.useraddLists.consignee.forEach((addListItem) => {
            if (addListItem.acquiescent) {
              this.userActiveAddName.consignee = addListItem
              this.findValue(addListItem.id, 'consignee')
            }
          })
        }
      })
    },
    handleChange() {

    },

  }
}

</script>
<style>
.el-popover {
  width: 330px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #dfdfdf;
}
</style>
<style lang="scss" scoped>
@import '../../../../../../css/mixin.scss';

#DeliveryDetails {
  min-height: 110vh;
  background: #FAFAFA;
  padding-bottom: 100px;
}

.DeliveryDetailcontent {
  padding-top: 30px;
  width: 1400px;
  margin: auto;

  .headerbox {
    width: 100%;
    margin-bottom: 20px;

    h1 {
      font-weight: 600;
      font-size: 20px;
      color: #121212;
      line-height: 32px;
      margin-bottom: 5px;
    }

    .DeliveryDetailsTitle {
      font-weight: 400;
      font-size: 16px;
      color: #121212;

      line-height: 20px;
    }

    .tishibox {

      min-width: 100px;

      height: 34px;
      line-height: 34px;
      background: #E8EDFA;
      border-radius: 10px;
      flex-shrink: 0;
      justify-content: center;
      padding: 8px 15px;
      font-weight: 400;
      font-size: 14px;
      color: #2052CE;

    }
  }

  .main {
    width: 100%;

    background: #FFFFFF;
    border-radius: 20px;
    padding: 30px 20px;

    .tablebox {


      .tablehead {
        height: 60px;
        background: #F5F5F5;
        border-radius: 12px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          line-height: 14px;
          text-align: center;
        }

        .index {
          flex: 0 0 160px;
        }

        .products {
          flex: 0 0 200px;


        }

        .specifications {
          flex: 0 0 120px;


        }

        .price {
          flex: 0 0 80px;
        }

        .num {
          flex: 0 0 80px;
        }

        .totalprice {
          flex: 0 0 100px;
        }

        .internationalfreight {
          flex: 0 0 120px;
        }

        .pickquantities {
          flex: 0 0 140px;
        }

        .remarks {
          flex: 0 0 160px;
        }
      }

      .tableboday {
        min-height: 100px;

        /deep/.el-collapse {
          width: 1360px !important;
          min-height: 60px;
          border-top: none;

          .el-collapse-item {
            width: 1360px !important;
            min-height: 60px;
            background: #FAFAFA;

            .el-collapse-item__header {
              height: 60px;
              display: flex;
              align-items: center;
            }

            .el-collapse-item__arrow {
              margin-left: 12px;
              color: #D12A1D;
              font-weight: 700;
            }

            .el-collapse-item__content {
              padding-bottom: 0px;
              padding-top: 20px;
              background: #FAFAFA;
            }
          }

          .el-collapse-item__wrap {
            border-bottom: 1px solid #DFDFDF;
            background: #FAFAFA;
          }
        }

        .ordersn {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          display: flex;
          align-items: center;


          span {
            font-weight: 400;
            font-size: 14px;
            margin-left: 14px;
            color: #D12A1D;

            &:hover {
              cursor: pointer;
            }
          }
        }

        .gooditem {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          min-height: 100px;
          padding: 0 20px;

          >div {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 14px;
            color: #121212;
            line-height: 14px;
            text-align: center;
          }

          .index {
            flex: 0 0 160px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .indexNum {
              width: 40px;
              display: flex;
              font-weight: bold;
              font-size: 14px;
              color: #121212;
              align-items: center;
              justify-content: center;
            }

            /deep/ .el-image {
              width: 100px;
              height: 100px;

              border-radius: 10px;

              >div {
                height: 100%;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .image-slot {

                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 30px;
                height: 100%;
                width: 100%;
              }
            }
          }

          .products {
            flex: 0 0 200px;

            .goodsTitle {
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // 四行文本溢出
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5;
              overflow: hidden;
              height: 78px;
              line-height: 16px;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              line-height: 16px;
            }
          }

          .specifications {
            flex: 0 0 120px;

            .detailOptBox {
              height: 90px;
              overflow-y: auto;
              overflow-x: hidden;

              &::-webkit-scrollbar {
                width: 6px;
              }

              p {
                display: flex;

                margin-bottom: 5px;
                font-size: 14px;
                color: #121212;
                line-height: 16px; // 文字换行 
                word-break: break-all;



                span {

                  font-size: 14px;
                  color: #121212;
                  line-height: 16px;
                }
              }
            }
          }

          .price {
            flex: 0 0 80px;
            font-weight: bold;
            font-size: 18px;
            color: #121212;
          }

          .num {
            flex: 0 0 80px;
            font-weight: bold;
            font-size: 18px;
            color: #121212;
          }

          .totalprice {
            flex: 0 0 100px;
            font-weight: bold;
            font-size: 18px;
            color: #121212;
          }

          .internationalfreight {
            font-weight: bold;
            font-size: 18px;
            color: #121212;
            flex: 0 0 120px;
          }

          .pickquantities {
            flex: 0 0 140px;
            font-weight: bold;
            font-size: 18px;
            color: #121212;
          }

          .remarks {
            p {
              flex: 0 0 160px;
              width: 160px;
              color: #121212;
              height: 100px;
              background: #FFFFFF;
              border-radius: 8px;
              border: 1px solid #DFDFDF;
              padding: 10px;
              text-align-last: left;

              &:last-child {
                color: #999999;
                white-space: nowrap;
                /* 不换行 */
                overflow: hidden;
                /* 隐藏超出的内容 */
                text-overflow: ellipsis;
                /* 显示省略号 */
              }

              // 文本溢出显示省略号


            }
          }
        }
      }


    }
  }

  /deep/.el-tabs {
    .el-tabs__header {

      margin-bottom: 20px;
      width: 1400px;
      height: 70px;
      background: #FFFFFF;
      border-radius: 20px;
      display: flex;
      padding: 0 20px;
      align-items: center;

      .el-tabs__nav-wrap {
        height: 32px;
      }
    }

    .el-tabs__nav-scroll {
      height: 32px;
    }

    .el-tabs__nav {
      height: 32px;
    }

    .el-tabs__item {
      height: 32px;
      font-weight: 400;
      font-size: 16px;
      color: #121212;
      text-align: center;
      line-height: normal;
    }

    .el-tabs__nav-wrap {
      height: 32px;

      &::after {
        display: none;
      }
    }

    .is-active {
      font-weight: 500;
      font-size: 16px;
      color: #D12A1D;
    }
  }

  //装箱单样式
  .Packinglist {
    width: 100%;
    padding-bottom: 10px;

    .headerrbox {
      width: 100%;
      min-height: 80px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 20px;
      margin-bottom: 20px;

      h2 {
        font-weight: bold;
        font-size: 16px;
        color: #121212;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .headerdeliveryorderbox {
        width: 100%;
        min-height: 28px;


        display: flex;
        flex-wrap: wrap;


        span {
          width: 200px;
          display: flex;
          font-weight: 500;
          font-size: 14px;
          color: #222222;
          align-items: center;
          justify-content: center;

          height: 28px;
          border-radius: 6px;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }

        .activepackingitem {
          background: rgba(209, 42, 29, 0.1);
          border-radius: 6px;
          font-weight: 500;

          color: #D12A1D;
          font-size: 14px;
          color: #D12A1D;
        }
      }
    }



    .costbox {
      .costboxrow {
        width: 100%;

        min-height: 444px;

        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;


        .Internationaltransportationcosts {
          width: 460px;
          min-height: 444px;
          background: #FFFFFF;
          border-radius: 20px;

          padding: 20px;

          h2 {

            font-weight: bold;
            font-size: 16px;
            color: #121212;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-bottom: 5px;

          }

          .cost {
            .costitem {
              display: flex;
              justify-content: space-between;
              align-items: center;

              min-height: 48px;
              line-height: 20px;
              border-bottom: 1px solid #DFDFDF;


              span {
                width: 200px;

                &:first-child {
                  font-weight: 400;
                  font-size: 14px;
                  color: #121212;
                  color: #666666 !important;
                  text-align: left;
                }

                &:last-child {
                  text-align: right;
                  font-weight: 400;
                  font-size: 14px;
                  color: #121212;
                  color: #222222;
                }
              }

              .huilv {
                font-weight: 400;
                font-size: 14px;
                color: #666666;
              }

              &:last-child {

                span {
                  &:first-child {
                    font-weight: bold;
                    font-size: 14px;
                    color: #121212;
                  }

                  &:last-child {
                    font-weight: bold;
                    font-size: 14px;
                    color: #D12A1D;
                  }
                }
              }

            }
          }

          .Packingliststatusbox {
            margin-top: 20px;
            min-height: 114px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;

            .Packingliststatus {
              display: flex;
              width: 100%;
              justify-content: space-between;
              align-items: center;

              span {
                font-weight: bold;
                font-size: 16px;
                ;
                color: #121212;
              }

              .status {
                padding: 5px 16px;
                min-height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #FEE8E8;
                border-radius: 8px;
                font-weight: bold;
                font-size: 14px;
                text-align: center;
                color: #D12A1D;

              }

              .afterPayment {
                background: #E7EDFB !important;
                border-radius: 8px;
                font-weight: normal;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                text-align: center;
                color: #2052CE !important;
              }
            }



            .pay {
              margin-top: 26px;
              width: 100%;
              height: 56px;
              background: #D12A1D;
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 18px;
              color: #FFFFFF;

              &:hover {
                cursor: pointer;
              }
            }

            .signfor {
              margin-top: 26px;
              width: 100%;
              height: 56px;
              background: #2052CE;
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 18px;
              color: #FFFFFF;

              &:hover {
                cursor: pointer;
              }
            }

          }
        }

        .Shippinginformation {
          width: 460px;
          min-height: 444px;
          background: #FFFFFF;
          border-radius: 20px;
          padding: 20px;

          h2 {
            font-weight: bold;
            font-size: 16px;
            color: #121212;
            line-height: 20px;
            font-style: normal;
            margin-bottom: 20px;
          }

          .informationbox {
            .information {
              display: flex;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 15px;
              line-height: 20px;

              span {
                width: 200px;
                // 放不下换行
                word-break: break-all;

                &:first-child {
                  font-weight: 400;
                  font-size: 14px;
                  color: #666666 !important;
                  text-align: left;
                }

                &:last-child {
                  text-align: right;
                  font-weight: bold;
                  font-size: 14px;
                  color: #121212;
                  color: #222222;
                }
              }
            }
          }
        }

        .Remarksofpackinglist {
          width: 440px;
          min-height: 444px;
          background: #ffffff;
          padding: 20px;
          border-radius: 6px;

          h2 {


            font-weight: bold;
            font-size: 16px;
            color: #121212;
            line-height: 20px;
            text-align: left;
            margin-bottom: 15px;
            font-style: normal;
          }

          textarea {
            width: 400px;
            height: 160px;
            background: #FAFAFA;
            border-radius: 12px;
            border: 1px solid #DFDFDF;
            padding: 15px;
            color: #121212;
            margin-bottom: 20px;
          }

          .order_sn {
            font-weight: 400;
            font-size: 14px;
            color: #D12A1D;
            text-decoration: underline;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }

    /deep/.el-table {
      border-radius: 8px;
      overflow: hidden;
    }

    .Logisticsinformation {
      min-height: 200px;

      background: #FFFFFF;
      border-radius: 20px;
      padding: 20px;

      // 配送单列表
      .Distributionlist {

        background: #FFFFFF;
        border-radius: 6px;
        margin-bottom: 30px;

        .waybill {
          font-weight: 400;
          font-size: 14px;
          color: #D12A1D;
          line-height: 20px;
          text-align: center;
          font-style: normal;
          text-decoration-line: underline;

          &:hover {
            cursor: pointer;
          }
        }

        .tip {
          font-weight: 400;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 20px;
          text-align: left;
          margin-top: 10px;
        }
      }

      .TrackingStatus {
        min-height: 104px;
        background: #FFFFFF;
        border-radius: 6px;


        h2 {
          font-weight: bold;
          font-size: 16px;
          color: #121212;
          line-height: 20px;
          text-align: left;
        }

        .iconbox {
          padding: 20px;
          display: flex;
          align-items: center;
          justify-content: center;

          .line {
            width: 240px;
            height: 2px;
            margin-bottom: 80px;
            background: #F8F8F8;
          }

          .iconitem {
            display: flex;
            flex-direction: column;
            align-items: center;

            min-height: 158px;

            .imgbox {
              width: 80px;
              height: 80px;
              background: #FAE9E8;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
            }



            p {
              margin-top: 20px;
              font-weight: bold;
              font-size: 14px;
              color: #121212;
              max-width: 90px;
              text-align: center;

            }
          }

          .activeicon {
            .imgbox {
              background: #D12A1D;
              border-radius: 50%;
            }

          }

        }

        .textareabox {
          min-height: 80px;
          background: #FFFFFF;
          border-radius: 6px;
          padding: 20px;


          .textareaItem {
            display: flex;
            align-items: center;
            height: 100%;

            .date {
              font-weight: 400;
              font-size: 14px;
              width: 120px;
              text-align: right;
              color: #666666;
              margin-right: 44px;
            }

            .timebox {
              flex: 1;

              display: flex;
              align-items: center;

              padding-left: 35px;
              border-left: 1px solid #D12A1D;
              position: relative;

              padding-top: 20px;
              padding-bottom: 20px;

              .icon {
                position: absolute;
                left: -6px;
                width: 12px;
                height: 12px;
                background-color: #fff;
                border-radius: 50%;
                border: 2px solid #D12A1D;
              }

              .rightbox {
                background: #FAFAFA;
                border-radius: 12px;
                padding: 5px 0px;
                width: 100%;




                .timeItem {
                  display: flex;
                  width: 100%;
                  padding: 0 20px;
                  background: #FAFAFA;
                  align-items: center;
                  min-height: 38px;
                  border-bottom: 1px solid #EDEDED;
                  line-height: 20px;

                  img {
                    width: 12px;
                    height: 12px;

                    margin-right: 9px;
                  }

                  .time {
                    min-width: 72px;
                    padding-right: 12px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                  }

                  .text {
                    font-weight: 400;
                    font-size: 14px;
                    color: #121212;
                    padding-left: 20px;
                    line-height: 20px;
                    border-left: 1px solid #EDEDED;
                  }

                  &:last-child {
                    border: none;
                  }
                }
              }


            }

            &:nth-child(odd) {
              .timebox {

                padding-top: 0px;
                padding-bottom: 0px;
              }
            }

            /* 第一个 .textareaItem 的 .timebox 从上到下一半 */
            &:first-child .timebox {
              border-left: none;
              /* 移除默认的 border-left */
              position: relative;

              &::before {
                content: '';
                position: absolute;

                bottom: 0;
                left: 0px;
                /* 对齐到 padding-left 的位置 */
                width: 1px;
                height: 50%;
                /* 设置高度为父元素的一半 */
                background-color: #D12A1D;
              }
            }

            // /* 最后一个 .textareaItem 的 .timebox 从下到上一半 */
            &:last-child {
              .timebox {
                border-left: none !important;
                /* 移除默认的 border-left */
                position: relative;

                &::before {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 0px;
                  /* 对齐到 padding-left 的位置 */
                  width: 1px;
                  height: 50%;
                  /* 设置高度为父元素的一半 */
                  background-color: #D12A1D;
                }
              }
            }
          }


        }

        .noData {
          height: 80px;
          background: #FFFFFF;
          border-radius: 6px;

          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .Packinglistdetails {


      background: #FFFFFF;
      border-radius: 20px;
      margin-top: 20px;
      padding: 20px;

      .detailscontent {
        height: 70px;
        background: #FFFFFF;
        border-radius: 6px;
        overflow: hidden;


        .headertitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;

          &:hover {
            cursor: pointer;
          }

          .left {
            display: flex;
            align-items: center;

            span {
              height: 30px;


              font-weight: bold;
              font-size: 16px;
              color: #121212;
              text-align: left;
              display: flex;
              align-items: center;
              margin-right: 8px;
            }


          }

          .right {
            display: flex;
            align-items: center;

            .tip {

              font-weight: 400;
              font-size: 12px;
              color: #666666;
              font-style: normal;
              margin-right: 8px;
            }
          }
        }

        .goods_title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          font-size: 12px;
          overflow: hidden;
          text-align: left;

        }

        .maintable {
          /deep/.el-collapse {
            border-top: 1px solid #D8D8D8;

            .el-collapse-item__header {
              border-bottom: 1px solid none;
              height: 90px;

              .itemheader {
                height: 90px;
                padding-top: 20px;

                .Cartonnumber {
                  display: flex;
                  align-items: center;
                  margin-bottom: 10px;
                  height: 20px;

                  span {

                    &:first-child {
                      font-weight: 400;
                      font-size: 14px;
                      color: #121212;
                      line-height: 20px;
                      display: flex;
                      margin-right: 10px;
                    }

                    &:last-child {
                      font-weight: bold;
                      font-size: 14px;
                      color: #D12A1D;
                      line-height: 20px;
                      text-align: left;
                    }
                  }
                }

                .specification {

                  display: flex;
                  width: 100%;
                  align-items: center;
                  min-height: 20px;

                  .samegoods,
                  .Weight,
                  .Volume,
                  .Length,
                  .Width,
                  .Height {

                    display: flex;
                    margin-right: 40px;

                    span {
                      display: flex;
                      align-items: center;

                      &:first-child {
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                        text-align: center;
                        margin-right: 8px;
                      }

                      &:last-child {
                        font-weight: bold;
                        font-size: 14px;
                        color: #121212;
                        line-height: 20px;
                      }
                    }
                  }


                }
              }

            }

            .el-collapse-item__arrow {
              width: 40px;
              height: 28px;
              border-radius: 8px;
              border: 1px solid #DFDFDF;
              background: #FFFFFF;
              border-radius: 6px;
              border: 1px solid #E2E2E2;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;


              &::before {

                transition: transform .3s;
              }

              &.is-active {

                // 取消它的旋转transform
                transform: none;

                &::before {
                  transform: rotate(90deg);
                  font-weight: 700;
                  color: #222222;
                  font-size: 14px;
                  transition: transform .3s;
                }
              }
            }

            .el-collapse-item__wrap {
              border-bottom: 1px solid #D8D8D8;
            }

            .el-collapse-item__content {
              padding-bottom: 20px;
            }
          }
        }
      }

      .goodimg {
        width: 80px;
        height: 80px;
        background: #ededed;
        border-radius: 6px;
      }

      .showCloseheight {
        height: auto !important;
        ;
      }
    }
  }

}
</style>